import Config from 'react-native-config'
import { isOsMobile } from '../../../util/util'

const REACT_APP_INSURANCE_ONBOARDING_LINK = isOsMobile()
  ? Config.REACT_APP_INSURANCE_ONBOARDING_LINK
  : window?._env_?.REACT_APP_INSURANCE_ONBOARDING_LINK ?? ''

export const carousalData = [
  {
    key: '1',
    imageName: require('../../../assets/images/banner_insurance.png'),
    link: REACT_APP_INSURANCE_ONBOARDING_LINK,
  },
  {
    key: '2',
    imageName: require('../../../assets/images/fraud_alert_1.jpg'),
  },
  {
    key: '3',
    imageName: require('../../../assets/images/fraud_alert_2.jpg'),
  },
  // {
  //   key: '4',
  //   imageName: require('../../../assets/images/bill_payments.png'),
  // },
  {
    key: '5',
    imageName: require('../../../assets/images/banner_voicebox.png'),
  },
]
